import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-preview-survey-multi-response',
  templateUrl: './preview-survey-multi-response.component.html',
  styleUrls: ['./preview-survey-multi-response.component.scss']
})
export class PreviewSurveyMultiResponseComponent {

  @Input() questions: any;
  @Input() isReadOnly: boolean;
  @Input() displayMode: string;
  constructor(public sanitizer: DomSanitizer) { }

}
